import axios from 'axios';
import { RoleAddRequest, RoleEditRequest } from 'src/models/roles';
import { get, post, put, remove } from './mainApi';

const authServiceBaseURL = process.env.REACT_APP_AUTH_ENDPOINT;

export const signIn = async (email: string, password: string) => {
  var response = await axios.post(
    authServiceBaseURL + 'signin',
    { email, password },
    {
      headers: { 'Content-Type': 'application/json' }
    }
  );

  return response;
};

export const forgotPassword = async (email: string) => {
  var response = await axios.post(
    authServiceBaseURL + 'forgot-password',
    email,
    {
      headers: { 'Content-Type': 'application/json' }
    }
  );
  return response;
};

export const resetPassword = async (
  email: string,
  token: string,
  password: string,
  confirmPassword: string
) => {
  var response = await axios.post(
    authServiceBaseURL + 'reset-password',
    {
      email,
      token,
      password,
      confirmPassword
    },
    {
      headers: { 'Content-Type': 'application/json' }
    }
  );
  return response;
};

export const getAllResources = async () => {
  var response = get(authServiceBaseURL + 'all-resources');
  return response;
};

export const addRole = async (data: RoleAddRequest) => {
  var response = post(authServiceBaseURL + 'roles', data);
  return response;
};

export const getAllRoles = async () => {
  var response = get(authServiceBaseURL + 'all-roles');
  return response;
};

export const getRoleByName = async (roleName: string) => {
  var response = get(authServiceBaseURL + `roles/${roleName}`);
  return response;
};

export const deleteRole = async (roleName: string) => {
  var response = remove(authServiceBaseURL + `role/${roleName}`);
  return response;
};

export const updateRole = async (data: RoleEditRequest) => {
  var response = put(authServiceBaseURL + `role`, data);
  return response;
};

export const getRolePermissions = async (mail) => {
  var response = get(`${authServiceBaseURL}role?email=${mail}`);
  return response;
};

export const getRoleEmployeePermissions = async (mail) => {
  var response = get(
    `${authServiceBaseURL}tab-permissions?email=${mail}&tab=Employee`
  );
  return response;
};
